/**
 * Confirmation message when removing product from minicart
 */
function confirmRemoveCart() {
  $('.remove_from_cart_button').click(function() {
    var confirm_remove_product = $('#confirm_remove_product').text();

    return confirm(confirm_remove_product);
  });
}

function menuDesktop() {
  $('#site-header-cart').trigger('hover');

  $('.main-nav--link').hover(function() {
    $(this).find('.main-nav--submenu-ct').addClass('open');
    $(this).find('.arrow-link').addClass('active');
  }, function() {
    $(this).find('.main-nav--submenu-ct').removeClass('open');
    $(this).find('.arrow-link').removeClass('active');
  });

  $('.submenu-item').hover(function() {
    let src = $(this).attr('data-img');
    $(this).closest('.main-nav--submenu').find('.img').attr('src', src);
  });

  confirmRemoveCart();

  //Run after WooCommerce AJAX cart update
  $(document.body).on('wc_fragments_refreshed', function() {
    confirmRemoveCart();
  });

  $(window).on('scroll', function() {
    if ($(this).scrollTop() == 0) {
      $('.header-top.desktop-only').removeClass('stickied');
      $('.mantion-top-search.desktop').removeClass('stickied');
    } else if ($(this).scrollTop() > 150) {
      $('.header-top.desktop-only').addClass('stickied');
      $('.mantion-top-search.desktop').addClass('stickied');
      let headerHeight = $('.header-top.desktop-only').outerHeight();
      $('.mantion-top-search.desktop').css('top', headerHeight + 'px');
    }
  });
}

function menuMobile() {
  $('.mobile-menu').on('click', '.mobile--burger', function() {
    $('.search-content .filters').hide();
    $('.search-content .ordering').hide();
    $('.mobile-mymantion--nav').removeClass('deployed');
    $(this).closest('.mobile-menu').toggleClass('deployed');
  });

  $('.mobile-menu').on('click', '.my-account-icon', function() {
    $('.search-content .filters').hide();
    $('.search-content .ordering').hide();
    $(this).closest('.mobile-menu').removeClass('deployed');
    $('.mobile-mymantion--nav').toggleClass('deployed');
  });

  $('.mobile-menu').on('click', '.menu-item-has-children', function() {
    $(this).toggleClass('active');
  });
}

export { menuDesktop, menuMobile };
